export default {
  setMigrationDialogHeader: 'Ustaw początek migracji',
  setMessage: 'Czy na pewno chcesz zresetować status migracji dla {count} {type}?\nW rezultacie wszystkie {type} zostaną zmigrowane od {date}.',
  setMigrationDialogErrorPast: 'Data musi być w przeszłości',
};
